module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-222.d9324b1.woff2";